// extracted by mini-css-extract-plugin
module.exports = {"floating":"styles_floating__HcbGj","floatingHidden":"styles_floatingHidden__5AdGl"};